export default "__VITE_ASSET__de4310f5__"